import Layout from '@/layout'

export const siteAsyncRoutes = [
  {
    path: '/admin-insurance-product',
    name: 'Site-Product',
    component: Layout,
    redirect: '/admin-insurance-product/main',
    meta: {
      title: '产品管理'
    },
    alwaysShow: true,
    children: [
      {
        path: 'main',
        component: () => import('@/views/site/product/list/main'),
        name: 'Site-Product-List',
        meta: {
          title: '主险管理',
          icon: 'link',
          roles: ['admin-insurance-product/read', 'admin-insurance-product/write']
        }
      },
      {
        path: 'attach',
        component: () => import('@/views/site/product/list/sub'),
        name: 'Site-Product-List-Attach',
        meta: {
          title: '附加险管理',
          icon: 'link',
          roles: ['admin-insurance-product/read', 'admin-insurance-product/write']
        }
      },
      {
        path: 'edit',
        component: () => import('@/views/site/product/edit/index'),
        name: 'Site-Product-List-Edit',
        hidden: true,
        meta: {
          title: '编辑产品',
          activeMenu: '/admin-insurance-product'
        }
      },
      {
        path: 'create',
        component: () => import('@/views/site/product/edit/index'),
        name: 'Site-Product-List-Create',
        hidden: true,
        meta: {
          title: '创建产品',
          activeMenu: '/admin-insurance-product'
        }
      }
    ]
  },
  {
    path: '/admin-insurance-city',
    name: 'Site-City',
    component: Layout,
    redirect: '/admin-insurance-city/list',
    meta: {
      title: '系统管理'
    },
    alwaysShow: true,
    children: [
      {
        path: 'social',
        component: () => import('@/views/site/city/list'),
        name: 'Site-City-List',
        meta: {
          title: '城市管理',
          icon: 'link',
          roles: ['admin-social-insurance/read', 'admin-social-insurance/write']
        }
      },
      {
        path: 'social-pay',
        component: () => import('@/views/site/city/social-pay'),
        name: 'Site-City-Social-Pay',
        hidden: true,
        meta: {
          title: '社保缴费',
          activeMenu: '/admin-insurance-city'
        }
      },
      {
        path: 'social-type',
        component: () => import('@/views/site/city/social-type'),
        name: 'Site-City-Social-Type',
        hidden: true,
        meta: {
          title: '社保类型',
          activeMenu: '/admin-insurance-city'
        }
      },
      {
        path: 'social-work',
        component: () => import('@/views/site/city/social-work'),
        name: 'Site-City-Social-Work',
        hidden: true,
        meta: {
          title: '职业匹配',
          activeMenu: '/admin-insurance-city'
        }
      },
      {
        path: 'insurer',
        component: () => import('@/views/site/insurer/list'),
        name: 'Site-Insurer-List',
        meta: {
          title: '保险公司',
          icon: 'link',
          roles: ['admin-insurer/read', 'admin-insurer/write']
        }
      },
      {
        path: 'channel',
        component: () => import('@/views/site/channel/list'),
        name: 'Site-Channel',
        meta: {
          title: '平台管理',
          icon: 'link',
          roles: ['admin-insurer/read', 'admin-insurer/write']
        }
      }
    ]
  },
  {
    path: '/admin-finance',
    name: 'Site-Finance',
    component: Layout,
    redirect: '/admin-finance/equiv',
    meta: {
      title: '业务&财务管理系统'
    },
    alwaysShow: true,
    children: [
      {
        path: 'reports',
        component: () => import('@/views/site/finance/business/index'),
        name: 'Site-Finance-Reports',
        meta: {
          title: '业务报表',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'reports2',
        component: () => import('@/views/site/finance/business2/index.vue'),
        name: 'Site-Finance-Reports2',
        meta: {
          title: '业务报表2',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'reports-finances',
        component: () => import('@/views/site/finance/reports-finances'),
        name: 'Site-Finance-Reports-Finances',
        meta: {
          title: '财务报表',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'reports-finances-renewal-Import',
        component: () => import('@/views/site/finance/reports-finances-renewal'),
        name: 'Site-Finance-Reports-Finances-Renewal-Import',
        meta: {
          title: '财务报表-续期',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'reports-finances-3',
        component: () => import('@/views/site/finance/reports/list'),
        name: 'Site-Finance-Reports-Finances-B',
        meta: {
          title: '财务报表2',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'equiv',
        component: () => import('@/views/site/finance/equiv/products'),
        name: 'Site-Finance-Equiv',
        meta: {
          title: '产品管理',
          icon: 'link',
          roles: ['admin-finance-equiv-factor/read', 'admin-finance-equiv-factor/write']
        }
      },
      {
        path: 'equiv-edit',
        component: () => import('@/views/site/finance/equiv/entry'),
        name: 'Site-Finance-Equiv-Edit',
        hidden: true,
        meta: {
          title: '产品编辑',
          icon: 'link',
          roles: ['admin-finance-equiv-factor/read', 'admin-finance-equiv-factor/write']
        }
      },
      {
        path: 'consultant',
        component: () => import('@/views/site/finance/consultant/list'),
        name: 'Site-Finance-Consultant-List',
        meta: {
          title: '咨询师列表',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'reports-finances-renewal',
        component: () => import('@/views/site/finance/reports/renewal'),
        name: 'Site-Finance-Reports-Finances-Renewal',
        hidden: true,
        meta: {
          title: '续保关联',
          icon: 'link',
          roles: ['admin-finance-report/sales']
        }
      },
      {
        path: 'consultant-reports-finances',
        component: () => import('@/views/site/finance/consultant/finances/list'),
        name: 'Site-Finance-Consultant-finances',
        meta: {
          title: '咨询师统计表',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'equiv-manager',
        component: () => import('@/views/site/finance/equiv-manager/list'),
        name: 'Site-Finance-Equiv-Manager',
        meta: {
          title: '折标管理',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'equiv-continue',
        component: () => import('@/views/site/finance/equiv-manager/continue'),
        name: 'Site-Finance-Equiv-Continue',
        hidden: true,
        meta: {
          title: '折标-续期佣金率',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'equiv-entry',
        component: () => import('@/views/site/finance/equiv-manager/entry'),
        name: 'Site-Finance-Equiv-Entry',
        hidden: true,
        meta: {
          title: '折标-列表',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'belonging-distributors',
        component: () => import('@/views/site/finance/belonging-distributors'),
        name: 'Site-Finance-Belonging-Distributors',
        meta: {
          title: '业务归属渠道',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      },
      {
        path: 'belonging-persons',
        component: () => import('@/views/site/finance/belonging-persons'),
        name: 'Site-Finance-Belonging-Persons',
        meta: {
          title: '推荐人列表',
          icon: 'link',
          roles: ['admin-finance-consultant/read', 'admin-finance-consultant/write']
        }
      }
    ]
  },
  {
    path: '/test',
    name: 'Site-Test',
    component: Layout,
    redirect: '/test/table',
    meta: {
      title: '测试',
      icon: 'qq'
    },
    hidden: true,
    children: [
      {
        path: 'table',
        component: () => import('@/views/site/finance/consultant/finances/test'),
        name: 'Site-Test-Table',
        hidden: true,
        meta: {
          title: '表格',
          icon: 'link'
        }
      }
    ]
  },
  {
    path: '/admin-fleabane',
    name: 'Site-Finance',
    component: Layout,
    redirect: '/admin-fleabane/sessions',
    meta: {
      title: '咨询预约'
    },
    alwaysShow: true,
    children: [
      {
        path: 'sessions',
        component: () => import('@/views/site/fleabanes/index'),
        name: 'Site-Fieabans-Sessions',
        meta: {
          title: '问卷',
          icon: 'link',
          roles: ['fleabane/read']
        }
      },
      {
        path: 'session',
        component: () => import('@/views/site/fleabanes/edit'),
        name: 'Site-Fieabans-Session',
        hidden: true,
        meta: {
          title: '问卷1',
          icon: 'link',
          roles: ['fleabane/read']
        }
      }
    ]
  },
  {
    path: '/admin-ind',
    name: 'Ind-Inquire',
    component: Layout,
    redirect: '/admin-ind/index',
    meta: {
      title: 'Ind'
    },
    hidden: true,
    children: [
      {
        path: 'index',
        redirect: './index/cate',
        component: () => import('@/views/site/ind/index'),
        name: 'Ind-Inquire-Index',
        meta: {
          title: 'Easy go、轻松聊',
          icon: 'link'
        },
        children: [
          {
            path: 'cate',
            component: () => import('@/views/site/ind/inquire/cate'),
            name: 'Ind-Inquire-Cate',
            meta: {
              title: '问卷',
              icon: 'link'
            }
          },
          {
            path: 'group',
            component: () => import('@/views/site/ind/inquire/group'),
            name: 'Ind-Inquire-Group',
            meta: {
              title: '问题组',
              icon: 'link'
            }
          },
          {
            path: 'question',
            component: () => import('@/views/site/ind/inquire/question'),
            name: 'Ind-Inquire-Question',
            meta: {
              title: '问题',
              icon: 'link'
            }
          },
          {
            path: 'stage',
            component: () => import('@/views/site/ind/customer/stage'),
            name: 'Ind-Customer-Stage',
            meta: {
              title: '阶段',
              icon: 'link'
            }
          },
          {
            path: 'origin',
            component: () => import('@/views/site/ind/customer/origin'),
            name: 'Ind-Customer-Origin',
            meta: {
              title: '来源',
              icon: 'link'
            }
          },
          {
            path: 'user',
            component: () => import('@/views/site/ind/user'),
            name: 'Ind-Inquire-User',
            meta: {
              title: '成员',
              icon: 'link'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/admin-set',
    name: 'Site-Set',
    component: Layout,
    redirect: '/admin-set/team',
    meta: {
      title: '设置'
    },
    alwaysShow: true,
    children: [
      {
        path: 'team',
        component: () => import('@/views/site/set/team'),
        name: 'Site-Set-Team',
        meta: {
          title: '团队管理',
          icon: 'link',
          roles: ['admin-team-entity/read', 'admin-team-entity/write']
        }
      },
      {
        path: 'user',
        component: () => import('@/views/site/set/user'),
        name: 'Site-Set-User',
        meta: {
          title: '员工账号',
          icon: 'link',
          roles: ['admin-user/read', 'admin-user/write']
        }
      },
      {
        path: 'account',
        component: () => import('@/views/site/set/account'),
        name: 'Site-Set-Account',
        meta: {
          title: '个人设置',
          icon: 'link'
        }
      }
    ]
  }
]
